import { Route, Routes } from 'react-router-dom';
import { Layout } from './Layout.js';
import { HomePage } from './pages/Home.js';

export function App() {
  return (
    <Routes>
      <Route element={<Layout appName="Folio" tagline="A family archive, gathered over generations." />}>
        <Route index element={<HomePage />} />
      </Route>
    </Routes>
  );
}
